import appendQuery from 'append-query'
import 'shared/util/canvas-to-blob-polyfill'

const API = 'wss://ws-imaging.giphy.com/imaging/merge'
const CANVAS = document.createElement('canvas')
const CONTEXT = CANVAS.getContext('2d')

export const WEB_SOCKETS = {}

export const convertFramesToVideo = ({ frames, fps = 15, jobId }) =>
    new Promise((resolve, reject) => {
        let { width, height } = frames[0].data

        // force width/height to be even number
        width = width % 2 === 0 ? width : width - 1
        height = height % 2 === 0 ? height : height - 1

        const socket = new WebSocket(appendQuery(API, { fps, width, height }))

        socket.onopen = () => {
            // draw all frame image data to buffer canvas
            // and send blobs to endpoint.
            Promise.all(
                frames.map(
                    ({ data }) =>
                        new Promise(resolve => {
                            CANVAS.width = data.width
                            CANVAS.height = data.height
                            CONTEXT.putImageData(data, 0, 0)
                            CANVAS.toBlob(blob => resolve(blob), 'image/jpeg', 1)
                        })
                )
            ).then(frames => {
                frames.forEach(blob => socket.send(blob))
                socket.send('all done!')
            })
        }

        if (jobId) {
            // if the promise was cancelable, then we'd just do that
            // but exposing a static object with jobIds will do
            WEB_SOCKETS[jobId] = socket
        }

        socket.onmessage = ({ data }) => {
            // wait for response object to come back
            if (typeof data === 'object' && data.size) {
                delete WEB_SOCKETS[jobId]
                resolve(data)
            }
        }

        socket.onclose = () => {
            delete WEB_SOCKETS[jobId]
        }

        socket.onerror = error => {
            delete WEB_SOCKETS[jobId]
            reject(error)
        }
    })

export default convertFramesToVideo
